import React, {useEffect, useState} from "react";
import {axiosInstance} from "../utilities/AxiosConfig";
import Cookies from "js-cookie";
import {notify} from "../components/toast";
import {ToastContainer} from "react-toastify";
import {MunshiMenu} from "../components/Menu";
import {Calendar} from "primereact/calendar";
import {jDateToMySql} from "../utilities/ToMySqlDate";
import {InputTextarea} from "primereact/inputtextarea";
import {Button} from "primereact/button";
import {generateRandomString} from "../utilities/randomGenerator";
import MfxOutputPanel from "../components/Manufacturing/MfxOutputPanel";
import {FloatLabel} from "primereact/floatlabel";
import {Auths} from "../utilities/getAuthDep";
import {useSpinner} from "../context/SpinnerContext";


export const MfxOutput = ({handle}) => {
    const {loading, setLoading} = useSpinner()
    const [itemList, setItemList] = useState([]);
    const [mfxList, setMfxList] = useState([]);
    const [companyName, setCompanyName] = useState("");
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [textAreaValue, setTextAreaValue] = useState("");

    useEffect(() => {

        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database') || "Test");
    }, [])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`biodata/`,).then((response) => {
            setCompanyName(response.data.name)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            () => {
                setLoading(false)
            }
        )
    }, []);
    useEffect(() => {
        setLoading(true)

        const sqlDate = jDateToMySql(selectedDate)

        axiosInstance.get(`/mfx/mode/${sqlDate}&OUPT`).then((response) => {
            if (response.data.length !== 0) {
                setMfxList(response.data)
            }
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [selectedDate])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get('/item/basic/').then((response) => {
            setItemList(response.data)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [])
    const saveMfx = (data) => {
        setLoading(true)
        if ((data.length === 1 && data[0].itemName === "" && data[0].quantity === 0)|| (data.length ===0)) {
            axiosInstance.delete(`/mfx/mode/${jDateToMySql(selectedDate)}&OUPT`).then((response) => {
                notify("Data Deleted", "success")
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(
                setLoading(false)
            )
            return;

        }

        let _data = data.filter((item) => item.itemName !== "")
        if (_data.length > 0) {
            _data = _data.map(it => {
                if (it.itemName !== "") {
                    return {
                        ...it,
                        code: it.code.trim(),
                        itemName: it.itemName.trim(),
                        itemId: itemList.find(item => item.name.trim() === it.itemName.trim()).id,
                        status: "OUPT",
                        id: 0
                    }
                }
            })
            axiosInstance.post(`/mfx/`, _data
            ).then((response) => {
                setMfxList(data)
                notify(response.data, "success")
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(
                setLoading(false)
            )
        } else {
            notify("Data Empty", "warning")
        }
    }

    const MfxSelect = () => {
        if (mfxList && itemList && !loading) {
            return (
                <>
                    <MfxOutputPanel mfxList={mfxList} setMfxList={setMfxList} saveMfx={(data) => saveMfx(data)}
                                    selectedDate={jDateToMySql(selectedDate)}
                                    itemList={itemList.map((item) => {
                                        return {
                                            id: item.id,
                                            name: item.name
                                        }
                                    })}
                    />
                </>

            )
        } else {
            return null
        }
    }
    const arrangeData = () => {
        let _dataArray = textAreaValue.split(/[\r\n]+/);
        _dataArray = _dataArray.filter(item => item.trim() !== "");
        if (_dataArray.length >= 1) {
            _dataArray.forEach(item => {
                const itemArray = item.split("-");
                if (itemArray.length === 5) {
                    setMfxList(prevData => [...prevData, {
                        id: generateRandomString(4),
                        code: item,
                        date: jDateToMySql(selectedDate),
                        itemId: itemArray[1],
                        itemName: itemList.find(item => item.id === parseInt(itemArray[1])).name.trim(),
                        quantity: parseInt(itemArray[4])
                    }]);
                }
            })
        }
    }

    if (!loading && itemList && mfxList && itemList.length > 0) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                <div
                    className="flex flex-column md:flex-row container  h-auto w-full  mt-2 mb-2 justify-content-start align-items-center md:justify-content-center md:align-items-center">
                    <div
                        className="flex flex-row card  h-auto w-fit pd-10 mt-2 mb-2 justify-content-center align-content-center bg-gray-100 shadow">
                        <div className="flex flex-column justify-content-between align-items-end">
                            <FloatLabel>
                                <Calendar style={{fontSize: '8px'}} id="buttondisplay" className="h-1rem pr-2 mr-2 p-3"
                                          dateFormat="dd/mm/yy"
                                          value={selectedDate} onChange={(e) => setSelectedDate(e.value)}
                                          selectionMode={"single"}/>
                                <label htmlFor="buttondisplay">Date</label>
                            </FloatLabel>
                            <Button icon="pi pi-wrench" className="h-1rem pr-2 mr-2 p-3 mb-3 pl-2 w-fit"
                                    onClick={arrangeData}/>

                        </div>
                        <FloatLabel>
                            <InputTextarea className="w-fit  m-2" value={textAreaValue} id="textarea"
                                           onChange={(e) => setTextAreaValue(e.target.value)} rows={5} cols={30}/>
                            <label htmlFor="textarea">Scan Data</label>
                        </FloatLabel>
                    </div>
                    <div className="container w-full md:w-7 h-full ">
                        <MfxSelect/>
                    </div>
                </div>
            </>
        );
    }

}
